document.addEventListener("DOMContentLoaded", function () {
  handleWhatMySizePopUp();
  setTimeout(setupBidirectionalSync, 1000);
});

function handleWhatMySizePopUp() {
  const modal = document.querySelector(".wms-modal");
  const backdrop = document.getElementById("wmsBackdrop");
  const triggerButton = document.querySelector(".wms-trigger");
  const closeButton = document.querySelector(".wms-modal__close");
  const radioInputs = document.querySelectorAll(".wms-modal__radio-input");
  const oldSizingRadios = document.querySelectorAll(
    "#original-version fieldset:last-of-type"
  );
  const sizingOptionsDropdownRadios = document.querySelectorAll(
    ".sizing-stack__size-option input"
  );

  if (!oldSizingRadios.length || !sizingOptionsDropdownRadios.length) {
    return;
  }

  // Store all focusable elements
  const getFocusableElements = () => {
    return Array.from(
      modal.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  };

  // Store the element that was focused before the modal was opened
  let previouslyFocusedElement = null;

  // Get scrollbar width to compensate for layout shift
  const getScrollbarWidth = () => {
    return window.innerWidth - document.documentElement.clientWidth;
  };

  // Function to open the modal
  function openModal() {
    // Store the currently focused element to return to later
    previouslyFocusedElement = document.activeElement;

    // Add active class to show the modal
    backdrop.classList.add("is-active");

    // Update ARIA attributes
    modal.setAttribute("aria-hidden", "false");
    backdrop.setAttribute("aria-hidden", "false");

    // Prevent scrolling without causing layout shift
    const scrollbarWidth = getScrollbarWidth();
    document.documentElement.style.setProperty(
      "--scrollbar-width",
      `${scrollbarWidth}px`
    );
    document.documentElement.classList.add("wms-scroll-lock");

    // Set focus on the modal
    modal.focus();

    // Add event listeners for accessibility
    document.addEventListener("keydown", handleKeyDown);

    // Prevent clicks inside modal from bubbling to backdrop
    modal.addEventListener("click", stopPropagation);
  }

  // Function to close the modal
  function closeModal() {
    backdrop.classList.remove("is-active");

    // Update ARIA attributes
    modal.setAttribute("aria-hidden", "true");
    backdrop.setAttribute("aria-hidden", "true");

    // Re-enable scrolling
    document.documentElement.classList.remove("wms-scroll-lock");

    // Remove event listeners
    document.removeEventListener("keydown", handleKeyDown);
    modal.removeEventListener("click", stopPropagation);

    // Return focus to the element that was focused before the modal was opened
    if (previouslyFocusedElement) {
      previouslyFocusedElement.focus();
    }
  }

  // Stop propagation to prevent clicks inside modal from closing it
  function stopPropagation(event) {
    event.stopPropagation();
  }

  // Handle keyboard events
  function handleKeyDown(event) {
    // Close on Escape key
    if (event.key === "Escape") {
      closeModal();
      return;
    }

    // Trap focus inside modal when Tab is pressed
    if (event.key === "Tab") {
      trapFocus(event);
    }
  }

  // Trap focus inside the modal
  function trapFocus(event) {
    const focusableElements = getFocusableElements();

    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    // If Shift+Tab on first element, move to last element
    if (event.shiftKey && document.activeElement === firstElement) {
      lastElement.focus();
      event.preventDefault();
    }
    // If Tab on last element, move to first element
    else if (!event.shiftKey && document.activeElement === lastElement) {
      firstElement.focus();
      event.preventDefault();
    }
  }

  // Event listeners
  triggerButton.addEventListener("click", openModal);
  closeButton.addEventListener("click", closeModal);

  // Close when clicking on backdrop (outside the modal)
  backdrop.addEventListener("click", (event) => {
    if (event.target === backdrop) {
      closeModal();
    }
  });

  // Handle radio button changes
  radioInputs.forEach((input) => {
    input.addEventListener("change", (event) => {
      stopPropagation(event);

      const isSmallDevice = window.matchMedia("max-width: 980px");

      // Synchronize the radio button states
      oldSizingRadios.forEach((fieldset) => {
        if (fieldset.classList.contains("hide-this")) {
          fieldset.classList.remove("hide-this");

          if (isSmallDevice) {
            const whatMySizeContronButtonWrapper = document.querySelector(
              ".v2pdp__abtest-sizing-info"
            );

            if (whatMySizeContronButtonWrapper) {
              whatMySizeContronButtonWrapper.style.marginBlockStart = "2.6rem";
            }
          }
        }

        const radio = fieldset.querySelector(
          `input[type="radio"][value="${input?.value}"]`
        );

        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }

        closeModal();
      });

      // Synchronize the dropdown radio buttons
      sizingOptionsDropdownRadios.forEach((radio) => {
        if (radio.value === input.value) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    });
  });
}

function setupBidirectionalSync() {
  // Get references to both sets of radio inputs
  const wmsRadios = document.querySelectorAll(".wms-modal__radio-input");
  const productOptionRadios = document.querySelectorAll(
    ".ombraz-v2pdp__product-options input[type='radio'][name='frame-size'], " +
      ".ombraz-v2pdp__product-options input[type='radio'][name='Frame Size']"
  );

  // Flag to prevent infinite loops when syncing
  let isSyncing = false;

  // Listen for changes on WMS popup radios
  wmsRadios.forEach((radio) => {
    radio.addEventListener("change", function (_event) {
      if (isSyncing) return; // Prevent infinite loop

      isSyncing = true;
      const selectedValue = this.value;

      // Update product option radios
      productOptionRadios.forEach((optionRadio) => {
        if (optionRadio.value === selectedValue) {
          optionRadio.checked = true;
          // Dispatch a native change event to trigger any other listeners
          optionRadio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });

      isSyncing = false;
    });
  });

  // Listen for changes on product option radios using event delegation
  document.addEventListener("change", function (event) {
    // Check if the changed element is a frame size radio in product options
    if (isSyncing) return;

    const target = event.target;
    if (
      target.matches(
        ".ombraz-v2pdp__product-options input[type='radio'][name='frame-size']"
      ) ||
      target.matches(
        ".ombraz-v2pdp__product-options input[type='radio'][name='Frame Size']"
      )
    ) {
      isSyncing = true;
      const selectedValue = target.value;

      // Update WMS popup radios
      wmsRadios.forEach((wmsRadio) => {
        if (wmsRadio.value === selectedValue) {
          wmsRadio.checked = true;
          // Dispatch a native change event
          wmsRadio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });

      // Make the frame size fieldset visible if it's hidden
      const frameSizeFieldset = document.querySelector(
        "#original-version fieldset:last-child"
      );
      if (
        frameSizeFieldset &&
        frameSizeFieldset.classList.contains("hide-this")
      ) {
        frameSizeFieldset.classList.remove("hide-this");
      }

      isSyncing = false;
    }
  });

  // Also sync with sizing dropdown radios if they exist
  const sizingOptionsDropdownRadios = document.querySelectorAll(
    ".sizing-stack__size-option input"
  );

  if (sizingOptionsDropdownRadios.length) {
    sizingOptionsDropdownRadios.forEach((radio) => {
      radio.addEventListener("change", function (event) {
        if (isSyncing) return;

        isSyncing = true;
        const selectedValue = this.value;

        // Update WMS popup radios
        wmsRadios.forEach((wmsRadio) => {
          if (wmsRadio.value === selectedValue) {
            wmsRadio.checked = true;
            wmsRadio.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });

        // Update product option radios
        productOptionRadios.forEach((optionRadio) => {
          if (optionRadio.value === selectedValue) {
            optionRadio.checked = true;
            optionRadio.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });

        isSyncing = false;
      });
    });
  }
}
